"use strict";

exports.__esModule = true;
exports.Icon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Plus = require("./iconComponents/Plus");

var _Minus = require("./iconComponents/Minus");

var _Tick = require("./iconComponents/Tick");

var _TriangleDown = require("./iconComponents/TriangleDown");

var _Calendar = require("./iconComponents/Calendar");

var _CheckboxCircle = require("./iconComponents/CheckboxCircle");

var _CircleOutline = require("./iconComponents/CircleOutline");

var _CircleSelected = require("./iconComponents/CircleSelected");

var _Cross = require("./iconComponents/Cross");

var _AvatarMan = require("./iconComponents/AvatarMan");

var _AvatarWoman = require("./iconComponents/AvatarWoman");

var _AvatarGirl = require("./iconComponents/AvatarGirl");

var _AvatarBoy = require("./iconComponents/AvatarBoy");

var _AvatarInfant = require("./iconComponents/AvatarInfant");

var _Star = require("./iconComponents/Star");

var _Clock = require("./iconComponents/Clock");

var _Call = require("./iconComponents/Call");

var _Picture = require("./iconComponents/Picture");

var _ChevronDown = require("./iconComponents/ChevronDown");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var IconMap = function IconMap(_ref) {
  var icon = _ref.icon,
      props = _objectWithoutPropertiesLoose(_ref, ["icon"]);

  switch (icon) {
    case 'plus':
      return _react["default"].createElement(_Plus.Plus, props);

    case 'minus':
      return _react["default"].createElement(_Minus.Minus, props);

    case 'triangle-down':
      return _react["default"].createElement(_TriangleDown.TriangleDown, props);

    case 'calendar':
      return _react["default"].createElement(_Calendar.Calendar, props);

    case 'tick':
      return _react["default"].createElement(_Tick.Tick, props);

    case 'cross':
      return _react["default"].createElement(_Cross.Cross, props);

    case 'checkbox-circle':
      return _react["default"].createElement(_CheckboxCircle.CheckboxCircle, props);

    case 'circle-outline':
      return _react["default"].createElement(_CircleOutline.CircleOutline, props);

    case 'circle-selected':
      return _react["default"].createElement(_CircleSelected.CircleSelected, props);

    case 'avatar-man':
      return _react["default"].createElement(_AvatarMan.AvatarMan, props);

    case 'avatar-woman':
      return _react["default"].createElement(_AvatarWoman.AvatarWoman, props);

    case 'avatar-girl':
      return _react["default"].createElement(_AvatarGirl.AvatarGirl, props);

    case 'avatar-boy':
      return _react["default"].createElement(_AvatarBoy.AvatarBoy, props);

    case 'avatar-infant':
      return _react["default"].createElement(_AvatarInfant.AvatarInfant, props);

    case 'star':
      return _react["default"].createElement(_Star.Star, props);

    case 'clock':
      return _react["default"].createElement(_Clock.Clock, props);

    case 'call':
      return _react["default"].createElement(_Call.Call, props);

    case 'picture':
      return _react["default"].createElement(_Picture.Picture, props);

    case 'chevron-down':
      return _react["default"].createElement(_ChevronDown.ChevronDown, props);

    default:
      break;
  }
};

var Icon = function Icon(_ref2) {
  var onClick = _ref2.onClick,
      props = _objectWithoutPropertiesLoose(_ref2, ["onClick"]);

  var handleClick = function handleClick(event) {
    event.preventDefault();
    onClick(event);
  };

  return _react["default"].createElement(IconMap, _extends({
    onClick: handleClick
  }, props));
};

exports.Icon = Icon;
Icon.propTypes = {
  icon: _propTypes["default"].string.isRequired,
  className: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  onClick: _propTypes["default"].func
};
Icon.defaultProps = {
  className: '',
  width: '24',
  height: '24',
  onClick: function onClick() {}
};
Icon.displayName = 'Icon';